import dayjs from "dayjs";

/**
 * Pasos del circuito con reglas propias. Los pasos se configuran en la base y se identifican
 * por su nombre: si se renombra uno, hay que actualizar esta constante y su par en el
 * backend (API/src/helpers/pedidoCompraPasos.js), que valida los mismos requisitos.
 */
export const PASOS = {
  NOTA_SOLICITUD: "NOTA SOLICITUD",
  PLIEGO_PARTICULAR: "PLIEGO PARTICULAR DE CONDICIONES CONCURSO DE PRECIOS",
  ACTIVACION: "ACTIVACION DE PROCESO DE CONTRATACION",
  COTIZACION: "COTIZACION RAZÓN SOCIAL",
  INFORME_PREADJUDICACION: "INFORME PREADJUDICACION",
  CARGA_PRESUPUESTO: "CARGA DE PRESUPUESTO",
  ORDEN_PROVISION: "ORDEN DE PROVISION",
};

/**
 * Cantidad de presupuestos que exige CARGA DE PRESUPUESTO según NIVELES_AUTORIZACION.
 * El tipo de compra lo define MONTOS_PRESUPUESTOS; este parámetro solo define cuántos
 * presupuestos se piden. Sin configuración se exige 1.
 */
export const presupuestosRequeridos = (tipoCompra, total, niveles) => {
  const lista = niveles?.[String(tipoCompra || "directa").toLowerCase()];
  if (!Array.isArray(lista)) return 1;
  const monto = Number(total) || 0;
  const nivel = lista.find(
    (n) => monto >= Number(n.desde || 0) && (n.hasta === null || n.hasta === undefined || monto <= Number(n.hasta))
  );
  return Number(nivel?.presupuestos_requeridos) || 1;
};

/**
 * Requisitos de un paso como lista [texto, cumple]. Un paso sin reglas no tiene requisitos.
 */
export const evaluarRequisitosPaso = (nombrePaso, ctx) => {
  const { pedido = {}, detalles = [], ahora = dayjs() } = ctx;
  switch (nombrePaso) {
    case PASOS.NOTA_SOLICITUD:
      return [["Datos generales (*)", Boolean(pedido.nombre && pedido.fechaSolicitud && pedido.objetoCompra)]];
    case PASOS.ACTIVACION:
      return [[
        "Seleccionar fechas de proceso en Datos Generales y enviar invitación",
        Boolean(pedido.licitacionInicio && pedido.licitacionFin),
      ]];
    case PASOS.COTIZACION: {
      const fin = pedido.licitacionFin ? dayjs(pedido.licitacionFin) : null;
      const cantidad = Number(ctx.cantidadCotizaciones) || 0;
      return [
        ["Cotización cerrada", Boolean(fin?.isValid() && fin.isBefore(dayjs(ahora)))],
        [`Cotizaciones de proveedores (${cantidad})`, cantidad > 0],
      ];
    }
    case PASOS.INFORME_PREADJUDICACION:
      return [[
        "Preadjudicación: guardar la selección de cotización de cada renglón",
        !(Number(ctx.cantidadCotizaciones) > 0) ||
          detalles.every((d) => Boolean(d.cotizacionSeleccionada) || Boolean(d.cotizacionSeleccionadaDesc)),
      ]];
    case PASOS.CARGA_PRESUPUESTO: {
      const requeridos = presupuestosRequeridos(pedido.tipoCompra, pedido.subtotalEstimado, ctx.niveles);
      return [[
        `Cargar ${requeridos} presupuesto${requeridos > 1 ? "s" : ""} de proveedor${requeridos > 1 ? "es" : ""}`,
        (Number(ctx.cantidadPresupuestos) || 0) >= requeridos,
      ]];
    }
    case PASOS.ORDEN_PROVISION:
      return [["Orden de provisión", Boolean(ctx.tieneOrdenProvision)]];
    default:
      return [];
  }
};
